import { useState, useEffect } from 'react';
import TabContextProvider from '../../Template/Context/TabContext';
import Header from '../../Template/Header/Header';
import Template from '../../Template/Template';
import { isMobile } from '../../utils/isMobile';
import ChatWidget from '../../ChatButton';

const Main = () => {
  const [visible, setVisible] = useState(false);
  const [brojPoruka, setBrojPoruka] = useState(0);
  useEffect(() => {
    const onClickHandler = (e) => {
      if (e.target.id === 'avatar') {
        setVisible(!visible);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener('click', onClickHandler);
    return () => window.removeEventListener('click', onClickHandler);
  }, [visible]);

  const main = (
    <TabContextProvider>
      {!isMobile() && <Header visible={visible} />}
      <ChatWidget brojPoruka={brojPoruka} setBrojPoruka={setBrojPoruka} />
      <Template />
    </TabContextProvider>
  );

  return main;
};

export default Main;
